import { Phone, Sparkles, ShieldAlert, MessageCircle } from 'lucide-react';
import { AGENCY_INFO } from '../data/content';

interface MobileStickyBarProps {
  onOpenDiagnostic: () => void;
}

export default function MobileStickyBar({ onOpenDiagnostic }: MobileStickyBarProps) {
  const whatsappUrl = `https://wa.me/${AGENCY_INFO.whatsappClean || '56978373379'}?text=${encodeURIComponent(
    'Hola Épica Comunicaciones, me gustaría solicitar un diagnóstico comunicacional o consultar por gestión de prensa.'
  )}`;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-slate-950/95 backdrop-blur-lg border-t border-slate-800 p-2.5 pb-safe shadow-2xl">
      <div className="grid grid-cols-3 gap-2 max-w-md mx-auto">
        {/* Call Hotline */}
        <a
          href={`tel:${AGENCY_INFO.phone}`}
          className="flex flex-col items-center justify-center py-2 px-1 rounded-xl bg-slate-900 border border-slate-800 text-slate-200 active:scale-95 transition-transform min-h-[44px]"
        >
          <Phone className="w-4 h-4 text-amber-400 mb-0.5" />
          <span className="text-[10px] font-bold">Llamar</span>
        </a>

        {/* WhatsApp Direct */}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-2 px-1 rounded-xl bg-emerald-950/80 border border-emerald-800/60 text-emerald-300 active:scale-95 transition-transform min-h-[44px]"
        >
          <MessageCircle className="w-4 h-4 text-emerald-400 mb-0.5" />
          <span className="text-[10px] font-bold">WhatsApp</span>
        </a>

        {/* Diagnostic Modal */}
        <button
          onClick={onOpenDiagnostic}
          className="flex flex-col items-center justify-center py-2 px-1 rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 text-slate-950 font-black active:scale-95 transition-transform min-h-[44px] shadow-lg shadow-amber-500/20"
        >
          <Sparkles className="w-4 h-4 text-slate-950 mb-0.5 animate-pulse" />
          <span className="text-[10px] font-extrabold uppercase tracking-tight">Diagnóstico</span>
        </button>
      </div>
    </div>
  );
}
